import {
  Action,
  MutationNominateNewDomainArgs,
  Network,
} from '@tribeplatform/gql-client/types'

import {
  UseMutationOptions,
  useMutation,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getProbeDomainKey } from '../../utils/keys/domain.key.js'
import { getNetworkKey } from '../../utils/keys/network.key.js'

export const useNominateNewDomain = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    Error,
    MutationNominateNewDomainArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Action, Error, MutationNominateNewDomainArgs>(
    input => client.network.nominateNewDomain(input),
    {
      onSuccess: (_, variables) => {
        const { domain } = variables
        const probeKey = getProbeDomainKey({
          variables: {
            domain,
          },
        })
        const networkKey = getNetworkKey()
        queryClient.setQueriesData<Network>(networkKey, old => {
          return {
            ...old,
            newDomain: domain,
          }
        })
        queryClient.invalidateQueries(probeKey)
        queryClient.invalidateQueries(networkKey)
      },
      ...useMutationOptions,
    },
  )
}
